import { render, staticRenderFns } from "./exchangeForm.vue?vue&type=template&id=23d19359&"
import script from "./exchangeForm.vue?vue&type=script&lang=js&"
export * from "./exchangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports